import React, { Fragment } from "react"
import { Box, Stack, Typography } from "@mui/material"
import { FILTER_ICONS_GREY, FILTER_ICONS_WHITE } from "../../../enums/iconsEnums"

export const NavigationButton = ({ isActive, page, customIcon = false, ...others }) => {
  return (
    <Fragment>
      {
        !(page?.hidden) && <Box
          sx={{
            backgroundColor: isActive && 'primary.main',
            width: '100%',
            padding: { xs: '16px 24px', md: '24px' },
            color: isActive ? '#FFF' : 'text.light',
            borderRadius: '100px',
            cursor: 'pointer',
            ':hover': {
              backgroundColor: !isActive && 'background.default',
              // transition: 'all 0.5s ease-in-out'
            }
          }}
          {...others}
        >
          <Stack direction={'row'} gap={1} alignItems={'center'}>
            {
              customIcon ? (isActive ? FILTER_ICONS_WHITE?.[page?.filterKey] : FILTER_ICONS_GREY?.[page?.filterKey]) : page?.icon
            }
            <Typography fontWeight={700}>{page?.title}</Typography>
          </Stack>
        </Box>
      }
    </Fragment>
  )
}